module.exports = __webpack_public_path__ + "static/shadow-361f263cedba947c5017c248f08d4bfe.mp4";